(function () {
    'use strict';
    app.controller('assignLicenseController', ['$scope', '$location', '$cookies', 'AuthenticationService', 'progressBarService', '$rootScope', '$timeout', 'UpgradeService', '$route', function ($scope, $location, $cookies, AuthenticationService, progressBarService, $rootScope, $timeout, upgradeService, $route) {

        if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined) {
            $location.path('/login');
            return;
        }
        
      
        $scope.disable = true;
        $scope.LicenseStatusOptions = ['Unassigned', 'Assigned'];
        $scope.subscriptionAssignedUsers = [];
        $scope.alreadyAssignCount = 0;
        $scope.isFormDirty = false;

        var subscriptionAssignedUsersList = function (count) {
            for (var i = 1; i <= count; i++) {
                $scope.subscriptionAssignedUsers.push(
                    {
                        eSpectraSubPackStartDate: null,
                        eSpectraSubPackEndDate: null,
                        eSpectraFirstName: '',
                        eSpectraLastName: '',
                        eSpectraSubAssignedPersonEmail: '',
                        selected: 'Unassigned',
                        isNew: 1
                    });

            }
        }

        //subscriptionAssignedUsersList();

        $scope.isError = false;
        $scope.isSuccess = false;

        var hideMessage = function () {
            $scope.isError = false;
            $scope.isSuccess = false;
            $scope.message = ''
        }

        $scope.goToAdminPackage = function (userId) {
            $scope.disable = true;
            $scope.subscriptionAssignedUsers = [];
            $scope.alreadyAssignCount = 0;
            $scope.getSubscriptionData(userId);
        }

        $scope.getSubscriptionData = function (userId) {
            var userId, eSpectraPrimaryAffiliationName;
            //userId = $cookies.get('UserId');
            //$scope.eSpectraPrimaryAffiliationName = $cookies.get('eSpectraPrimaryAffiliationName') == "" ? "----" : $cookies.get('eSpectraPrimaryAffiliationName');
            progressBarService.showProgressBar();
            upgradeService.getSubscriptionData(userId).then(function (response) {

                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    //$timeout(hideMessage, 10000);
                }
                else {
                    progressBarService.hideProgressBar();
                    $scope.subscribtionDetails = response.data;
                    $scope.selectedPackId = $scope.subscribtionDetails.eSpectraSubPackID;
                    $scope.selectedOwnerId = userId;
                    subscriptionAssignedUsersList($scope.subscribtionDetails.eSpectraSubPurchNum)
                    angular.forEach(response.data.subscriptionAssign, function (key, index) {
                        if (key.eSpectraSubAssignedPersonEmail != "") {
                            $scope.subscriptionAssignedUsers[index].eSpectraSubAssignedPersonEmail = key.eSpectraSubEmail == "" ? key.eSpectraSubAssignedPersonEmail : key.eSpectraSubEmail;
                            $scope.subscriptionAssignedUsers[index].selected = 'Assigned';
                            $scope.subscriptionAssignedUsers[index].eSpectraSubPackStartDate = key.eSpectraSubPackStartDate;
                            $scope.subscriptionAssignedUsers[index].eSpectraSubPackEndDate = key.eSpectraSubPackEndDate;
                            $scope.subscriptionAssignedUsers[index].eSpectraFirstName = key.eSpectraFirstName;
                            $scope.subscriptionAssignedUsers[index].eSpectraLastName = key.eSpectraLastName;
                            $scope.subscriptionAssignedUsers[index].isDisabled = true;
                            $scope.alreadyAssignCount = index + 1;
                            $scope.subscriptionAssignedUsers[index].isNew = 0;
                        }
                    });
                }
                progressBarService.hideProgressBar();
            });
        }

        $scope.getSelectedPackageById = function (packId, ownerId) {
            $scope.selectedPackId = packId;
            $scope.selectedOwnerId = ownerId;
            progressBarService.showProgressBar();
            $scope.subscriptionAssignedUsers = [];
            upgradeService.getSelectedPackageById(packId, ownerId).then(function (response) {

                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    //$timeout(hideMessage, 10000);
                }
                else {
                    progressBarService.hideProgressBar();
                    $scope.subscribtionDetails.eSpectraSubPurchNum = response.data.eSpectraSubPurchNum;
                    $scope.subscribtionDetails.eSpectraSubPackStartDate = response.data.eSpectraSubPackStartDate;
                    $scope.subscribtionDetails.eSpectraSubPackEndDate = response.data.eSpectraSubPackEndDate;
                    subscriptionAssignedUsersList(response.data.eSpectraSubPurchNum)
                    angular.forEach(response.data.subscriptionAssign, function (key, index) {
                        if (key.eSpectraSubAssignedPersonEmail != "") {
                            $scope.subscriptionAssignedUsers[index].eSpectraSubAssignedPersonEmail = key.eSpectraSubEmail == "" ? key.eSpectraSubAssignedPersonEmail : key.eSpectraSubEmail;
                            $scope.subscriptionAssignedUsers[index].selected = 'Assigned';
                            $scope.subscriptionAssignedUsers[index].eSpectraSubPackStartDate = key.eSpectraSubPackStartDate;
                            $scope.subscriptionAssignedUsers[index].eSpectraSubPackEndDate = key.eSpectraSubPackEndDate;
                            $scope.subscriptionAssignedUsers[index].eSpectraFirstName = key.eSpectraFirstName;
                            $scope.subscriptionAssignedUsers[index].eSpectraLastName = key.eSpectraLastName;
                            $scope.subscriptionAssignedUsers[index].isDisabled = true;
                            $scope.alreadyAssignCount = index + 1;
                            $scope.subscriptionAssignedUsers[index].isNew = 0;
                        }
                    });
                }
                progressBarService.hideProgressBar();
            });
        }

        $scope.getSubscriptionData($cookies.get('UserId'));

        $scope.onChange = function (index, _value, name) {
            var elemSelect = $('.sel1')[index];
            if (_value == '') {
                $scope.removeAssign(index);
            }
            var filterednames = $scope.subscriptionAssignedUsers.filter(function (obj) {
                return (obj.eSpectraSubAssignedPersonEmail === _value && _value != '');
            });

            if (filterednames.length > 1) {
                $scope.licenceForm[name].$dirty = true;
                $scope.licenceForm[name].$invalid = true;
                $scope.licenceForm.$invalid = true;
                $scope.apply();
            }



            $scope.isFormDirty = true;
        }

        $scope.removeAssign = function (index) {

            //$scope.subscriptionAssignedUsers[index].eSpectraSubAssignedPersonEmail = "";
            //$scope.subscriptionAssignedUsers[index].eSpectraFirstName = "";
            //$scope.subscriptionAssignedUsers[index].eSpectraLastName = "";
            $scope.subscriptionAssignedUsers[index].selected = 'Unassigned';
            $scope.isDeleteLicence = true;
            $scope.subscriptionAssignedUsers[index].isDisabled = false;

            $scope.isFormDirty = true;
        }
        $scope.setLicenseKeyStatus = function () {
            $('#confirmChanges').modal('hide');
            progressBarService.showProgressBar();
            var userId, isSubscribePackage, i, noOfAssignedPerson = 0, memberList = [];
            var packId = $scope.selectedPackId;
            var startDate = "", endDate = "";
        
            startDate = $scope.subscribtionDetails.eSpectraSubPackStartDate.substr(0, 10);
            endDate = $scope.subscribtionDetails.eSpectraSubPackEndDate.substr(0, 10);
            if ($scope.validateInviteMemmber()) {

                 userId = $cookies.get("UserId");
                 isSubscribePackage = $scope.subscribtionDetails.eSpectraSubPurchNum; //$cookies.get("isSubscribePackage");                

                for (i = 0; i < $scope.subscriptionAssignedUsers.length; ++i) {
                    if ($scope.subscriptionAssignedUsers[i].eSpectraSubAssignedPersonEmail.length > 0) {
                        //if ($scope.subscriptionAssignedUsers[i].selected == 'Assigned') {
                        //noOfAssignedPerson += 1;
                        memberList.push({
                            'eSpectraLicenceKeyStatus': $scope.subscriptionAssignedUsers[i].selected,
                            'eSpectraSubAssignedPersonEmail': $scope.subscriptionAssignedUsers[i].eSpectraSubAssignedPersonEmail,
                            'Status': $scope.subscriptionAssignedUsers[i].isNew
                        });
                        //}
                    }
                }

                if (memberList.length <= 0) {
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    $scope.message = 'There are no users to submit.';
                    progressBarService.hideProgressBar();
                    //$timeout(hideMessage, 10000);
                    
                    return false;
                }

                if (noOfAssignedPerson <=parseInt(isSubscribePackage)) {
                    upgradeService.setLicenseKeyStatus(memberList, userId, startDate, endDate, packId).then(function (response) {
                        progressBarService.hideProgressBar();
                        if (response != null && response.data.message != undefined) {
                            $scope.message = response.data.message;
                            $scope.isError = true;
                            $scope.isSuccess = false;

                        }
                        else if (response.data == true) {
                            $scope.isFormDirty = false;
                            sendNotification(memberList, startDate, endDate);
                            $scope.isError = false;
                            $scope.isSuccess = true;
                            $scope.message = 'Changes applied successfully.';
                            var count = 0;
                            for (var index in memberList) {
                                if (memberList[index].Status == '1') {
                                    count++;
                                }
                            }
                            if (count > 0) {
                                $location.path('licenseThankYou');
                            } else {
                                $scope.getSelectedPackageById($scope.selectedPackId, $scope.selectedOwnerId);
                            }
                        }
                        else if (response.data == false) {
                            $scope.isError = true;
                            $scope.isSuccess = false;
                            $scope.message = 'error:Unable to Send Email?';
                        }

                        //$timeout(hideMessage, 10000);
                      
                    });
                }
                else {
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    $scope.message = 'error:Requested mail action aborted: exceeded SubscribedPackage.';
                    //$timeout(hideMessage, 10000);
                    progressBarService.hideProgressBar();
                }

            }
            else {
                progressBarService.hideProgressBar();
            }

        
           
        }


        $scope.validateInviteMemmber = function () {
           
            var returnVal = true;
            var isEmailEnter = false;

            angular.forEach($("#CountInput input[type='text']"), function (value, index) {
                if (angular.element(value).val() != '') {
                    var emailregx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                    if (emailregx.test(angular.element(value).val())) {

                        $(value).siblings("label").find("span").fadeOut();
                        isEmailEnter = true;
                    }
                    else {

                        if (returnVal) {
                            $(value).focus();
                        }
                        $(value).siblings("label").find("span").fadeIn();
                        returnVal = false;
                    }

                }
                else {

                    //if (returnVal && !isEmailEnter) {
                    //    $(value).focus();
                    //}
                    //$(value).siblings("label").find("span").fadeIn();
                    returnVal = true;// isEmailEnter;
                }
            })

            if (!returnVal) {

                this.inviteForm.$dirty = true;
                var FieldShellelements, i;
                FieldShellelements = $("#CountInput div input");
                for (i = 0; i < FieldShellelements.length; i++) {
                    var inviteUserName = FieldShellelements[0].name;
                    this.inviteForm['eSpectraSubAssignedPersonEmail' + i].$dirty = true;
                };
            }
            return returnVal;
        }

        var sendNotification = function (memberList, startDate, endDate) {
            var adminEmailId = $cookies.get('emailId');
            upgradeService.sendLicenseNotification(memberList, adminEmailId, startDate, endDate);
        }

        $scope.reload = function () {
            $scope.isFormDirty = false;
            $location.path('assignlicencekey');
            $route.reload();
        }

        //$scope.$on('$locationChangeStart', function (event) {
        //    if ($scope.isFormDirty == true) {
        //        var answer = confirm("Are you sure you want to leave this page?")

        //        if (!answer) {
        //            event.preventDefault();
        //        }
        //    }
        //});

    }]);
})();